import _ from "lodash";
import { TranslateService } from 'shared';


export class AgGridSquirrelEnvironmentSettings {

    constructor(private translate: TranslateService) {}

    public agGridSquirrelEnvironmentSettings = {
        rowModelType: 'infinite' as any,
        //virtualPaging: true,
        //enableServerSideSorting: true,
        //enableServerSideFilter: true,
      rowSelection: { mode: 'singleRow', checkboxes: false } as any,
        //rowDeselection: true,
        rowHeight: 45,
        cacheBlockSize: 10000,
        cacheOverflowSize: 2,
        maxConcurrentDatasourceRequests: 1,
        paginationPageSize: 30,
        infiniteInitialRowCount: 1,
        columnDefs: [
          { field: 'name', headerName: `Name`, sortable: true, filter: true },
          { field: 'url', headerName: `Url`, sortable: true, filter: true },
          // { field: 'numberOfMigrations', headerName: `Number Of Migrations`, sortable: true, filter: true },
          // { field: 'migratedWhen', headerName: `Migration Date`, sortable: true, filter: true },
          {
            headerName: `Actions`,
            cellRenderer: 'buttonRenderer',
            cellRendererParams: {
              icon_edit: 'edit',
              icon_delete: 'delete'
            },
          },
        ],
        defaultColDef: {
          flex: 1,
          resizable: true,
          minWidth: 100,
          editable: false
        }
      }
}